import { AxiosInstance } from "axios"
import { Order } from "../../../../merchant/controlKitchenTypes"
import { DateType } from "../../../../../shared/components/filters/selectDateTypeFilter/SelectDateTypeFilter"

export enum ArchivePOSTransactions {
    ARCHIVE_POS_TRANSACTIONS = "archive-pos-transactions",
    ARCHIVE_WALLET_REFILL_TRANSACTIONS = "archive-wallet-refill-transactions",
}

type FetchPOSTransactionsParams = Readonly<{
    userId: number
    startDate?: string
    endDate?: string
    dateType?: DateType
}>

export type FetchPOSTransactionsResponse = Readonly<{
    orders: Order[] | null
}>

export async function fetchPOSTransactions(
    { userId, ...rest }: FetchPOSTransactionsParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<FetchPOSTransactionsResponse> {
    const url = `/users/${userId}/archive/pos`

    const { data } = await axios.get(url, {
        params: rest,
        signal,
    })

    return data
}
